import {  UnAuthApiService } from "../../config/apiServices";
import { GET_CITY_URL, GET_DISTRICT_URL, GET_BLOCK_URL, GET_COUNTRY_URL, GET_STATE_URL, GET_SPORT_URL } from "../../config/commonApiUrl/CommonApiUrlConfig";

export const getAllCountryList = () => {
    return UnAuthApiService.get(GET_COUNTRY_URL);
};


export const getAllStateList = (countryId) => {
  return UnAuthApiService.get(`${GET_STATE_URL}${countryId}`);
};


export const getAllCityList = (stateId) => {
  return UnAuthApiService.get(`${GET_CITY_URL}${stateId}`);
};

export const getAllSportList = () => {
  return UnAuthApiService.get(`${GET_SPORT_URL}`);
};

export const getAllDistrictList = (stateId) => {
  return UnAuthApiService.get(`${GET_DISTRICT_URL}${stateId}`);
};

export const getAllBlockList = (districtId) => {
  return UnAuthApiService.get(`${GET_BLOCK_URL}${districtId}`);
};